import React from 'react';
import { f1, linePath } from './scale';

/** Σημεία της γραμμής: ίσα διαστήματα, κάθετα min→max· όλα ίσα → στη μέση. */
export function sparkPoints(values: number[], w: number, h: number, pad = 4): Array<[number, number]> {
  const n = values.length;
  if (n < 2) return [];
  const mn = Math.min(...values);
  const mx = Math.max(...values);
  const rng = mx - mn;
  return values.map((v, i) => [
    pad + (i * (w - pad * 2)) / (n - 1),
    rng === 0 ? h / 2 : pad + (h - pad * 2) * (1 - (v - mn) / rng),
  ]);
}

/** Τάση 7 ημερών κάτω από ένα νούμερο: ουδέτερη γραμμή, η τελευταία τιμή τελεία στο χρώμα. */
export const Sparkline: React.FC<{ values: number[]; width?: number; height?: number; label: string }> = ({ values, width = 150, height = 26, label }) => {
  const pts = sparkPoints(values, width, height);
  if (pts.length === 0) return null;
  const last = pts[pts.length - 1];
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} role="img" aria-label={label} data-testid="sparkline">
      <path className="xh-spk" d={linePath(pts)} />
      <circle className="xh-dot" cx={f1(last[0])} cy={f1(last[1])} r={3.5} data-testid="spark-dot" />
    </svg>
  );
};

export default Sparkline;
